'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponsService = function () {
  function CouponsService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CouponsService);
    this.api = Api;
  }

  (0, _createClass3.default)(CouponsService, [{
    key: 'loadCoupons',
    value: function loadCoupons(data) {
      var url = '/coupons/list';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getCoupon',
    value: function getCoupon(id, type) {
      return this.api.call({
        method: 'get',
        url: '/coupons/get/' + id
      });
    }
  }, {
    key: 'updateCoupon',
    value: function updateCoupon(data, id) {
      var url = '/coupons/updateCoupon/' + id;
      return this.api.call({
        method: 'put',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeCoupon',
    value: function removeCoupon(id) {
      var url = '/coupons/removeCoupons/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'updateCouponStatus',
    value: function updateCouponStatus(data) {
      var url = '/coupons/updateCouponStatus';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'createCoupon',
    value: function createCoupon(data) {
      var url = '/coupons/createCoupon';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }]);
  return CouponsService;
}();

// WEBPACK FOOTER //


exports.default = CouponsService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/coupons/services/coupon.service.js
 **/